// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.
import _wsShared from '@symbo-ls/workspace-shared'
const shellGetSDK = (...args) => _wsShared.functions.getSDK(...args)

// SDK-only demo provisioning. Calls the public POST /core/demo/start route
// through the SDK's AuthService.startDemo, which mints a demo access/refresh
// token and applies it to localStorage via the TokenManager automatically —
// so the caller only needs to full-reload afterward for the shell to take the
// authed branch and mount into the demo org.
//
// EXCEPTION (server core/auth-takeover-paths B-5): an email that already has an
// account (demo row, or a real account from round 2) gets NO tokens — the
// server mails a sign-in link and resolves
// `{ isNew: false, signInLinkSent: true }`. The gate reads that field from the
// resolved value; it never infers a sign-in from the SDK's auth event.
//
// Invoked from the gate page via `el.call('startDemo', email)` (no imports
// between project files; the page never closes over getSDK directly). Resolves
// with the SDK's response data on success; rejects with the SDK error on
// failure — the page inspects `err.cause.status === 409` (existing real
// account) vs. everything else to pick the message.
export const startDemo = async (email) => shellGetSDK().startDemo({ email })
